import {TaskProperties} from "../../../../../../../../core/model2/task/properties/properties";
import TaskNotes from "../../../../../../../../core/model2/task/task-view/notes";
import Task from "../../../../../../../../core/model2/task/task";
import {ModelInterface} from "../../../../../../../../core/data-structures/collection";
import {TemplateDataCollection} from "./collection";
import TodoListCollection from "../../../../../../../../core/model2/todo/todo-list/todo-list-collection";



export default class TemplateData implements ModelInterface {

    public id               : ID                // Not in use
    // Only set for subtasks - the title of the template itself lives in taskType.templateTitle
    public title            : string
    public descriptionTxt   : string
    public subtasks         : TemplateDataCollection
    public notes            : TaskNotes
    // public checklist        : TodoListCollection
    public checklist        : any
    public properties       : TaskProperties
    public customFieldsData : DictionaryStringAny
    public estimate         : number | null
    public priority         : number | null
    public storyPoints      : number | null

    constructor(data: any) {
        this.id                 = null
        this.title              = data?.title || ""
        this.descriptionTxt     = _.get(data, "descriptionTxt", "")
        this.subtasks           = TemplateDataCollection.initFromJson(_.get(data, "subtasks", []))
        this.notes              = TaskNotes.initFromJson(new Task({}), _.get(data, "notes", []))
        // this.checklist          = TodoListCollection.initFromJson(_.get(data, "checklist", []))
        this.checklist          = _.get(data, "checklist", [])
        this.properties         = new TaskProperties(_.get(data, "properties", {}))
        this.customFieldsData   = _.get(data, "customFieldsData", {})
        this.estimate           = data?.estimate || null
        this.priority           = _.get(data, "priority", 0)
        this.storyPoints        = _.get(data, "storyPoints", null)
    }


    toJSON(): JSONObject {
        return {
            title               : this.title,
            descriptionTxt      : this.descriptionTxt,
            subtasks            : this.subtasks.toJSON(),
            notes               : this.notes.toJSON(),
            checklist           : this.checklist,
            properties          : !!this.properties ? this.properties.toJSON() : null,
            customFieldsData    : this.customFieldsData,
            estimate            : this.estimate,
            priority            : this.priority,
            storyPoints         : this.storyPoints
        }
    }
}
